// Stepped walkthrough. Progressive enhancement: without this file every panel is visible
// and the sequence reads as a normal stack, so nothing is hidden behind JS.
(function () {
  function init(root) {
    if (root.dataset.swSliderReady) return;
    root.dataset.swSliderReady = '1';

    var tabs = Array.prototype.slice.call(root.querySelectorAll('.sw-slider__tab'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('.sw-slider__panel'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('.sw-slider__dot'));
    var prev = root.querySelector('[data-sw-prev]');
    var next = root.querySelector('[data-sw-next]');
    if (panels.length < 2) return;

    root.classList.add('sw-slider--ready');
    var current = 0;

    function show(i, focusTab) {
      current = Math.max(0, Math.min(panels.length - 1, i));
      panels.forEach(function (p, n) { p.classList.toggle('is-active', n === current); });
      dots.forEach(function (d, n) { d.classList.toggle('is-active', n === current); });
      tabs.forEach(function (t, n) {
        var on = n === current;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        if (on && focusTab) t.focus();
      });
      if (prev) prev.disabled = current === 0;
      if (next) next.disabled = current === panels.length - 1;

      // Keep the active step visible on narrow screens without scrolling the page.
      var tab = tabs[current];
      var rail = root.querySelector('.sw-slider__rail');
      if (tab && rail && rail.scrollWidth > rail.clientWidth) {
        rail.scrollTo({
          left: tab.offsetLeft - (rail.clientWidth - tab.offsetWidth) / 2,
          behavior: 'smooth',
        });
      }
    }

    tabs.forEach(function (t, n) {
      t.addEventListener('click', function () { show(n); });
    });
    if (prev) prev.addEventListener('click', function () { show(current - 1); });
    if (next) next.addEventListener('click', function () { show(current + 1); });

    root.querySelector('.sw-slider__rail').addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); show(current + 1, true); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); show(current - 1, true); }
      else if (e.key === 'Home') { e.preventDefault(); show(0, true); }
      else if (e.key === 'End') { e.preventDefault(); show(panels.length - 1, true); }
    });

    // Swipe on touch. Ignore mostly-vertical drags so the page still scrolls.
    var x0 = null, y0 = null;
    var stage = root.querySelector('.sw-slider__stage');
    stage.addEventListener('touchstart', function (e) {
      x0 = e.touches[0].clientX; y0 = e.touches[0].clientY;
    }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      var dy = e.changedTouches[0].clientY - y0;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) show(current + (dx < 0 ? 1 : -1));
      x0 = null; y0 = null;
    }, { passive: true });

    show(0);

    // Hidden panels keep loading="lazy", which never fires while they are display:none,
    // so the first click on a step would show a blank frame. Promote them once the page
    // is idle: an eager img still fetches inside a hidden container.
    var warm = function () {
      root.querySelectorAll('.sw-slider__panel img[loading="lazy"]').forEach(function (img) {
        img.loading = 'eager';
      });
    };
    if ('requestIdleCallback' in window) requestIdleCallback(warm, { timeout: 2500 });
    else setTimeout(warm, 1200);
  }

  function boot() {
    document.querySelectorAll('[data-sw-slider]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  // Theme editor re-renders sections in place.
  document.addEventListener('shopify:section:load', boot);
})();
